/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ReportWrapper_viewer = {|
  +roles: ?$ReadOnlyArray<?string>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReportWrapper_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "roles",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ReportHeader_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "AdminReportGrid_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserReportGrid_viewer",
      "args": null
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/__generated__/ReportWrapper_viewer.graphql.js